module.exports = __webpack_public_path__ + "static/media/faq-collapse.d0a18765.svg";